import compliance from './compliance'
import controllers from './controllers'
import queryDetails from './queryDetails'
import getRecord from './getRecord'

export const complianceService = compliance
export const controllersService = controllers
export const queryDetailsService= queryDetails
export const getRecordService = getRecord